export default color =>
  `color-color${color[0].toUpperCase() + color.substring(1)}`
